import React, {useState} from 'react'
import 'bootstrap-icons/font/bootstrap-icons.css';
import { Container, Row, Col, Carousel, Nav, Card, Badge } from 'react-bootstrap';
import img1 from '../Components/Images/Retail weighing/AIScale/910WKB frontview.jpg'
import img2 from '../Components/Images/Retail weighing/AIScale/910-2.png'
import img3 from '../Components/Images/Retail weighing/AIScale/725-4.png'
import img4 from '../Components/Images/Retail weighing/AIScale/666-1.jpg'



function AIScale() {

  const featureIcons = [
  { icon: "robot", text: "AI PRODUCT RECOGNITION" },
  { icon: "eye-fill", text: "COMPUTER VISION" },
  { icon: "lightning-charge", text: "INSTANT ITEM IDENTIFICATION" },
  { icon: "database", text: "AUTO-PLU GENERATION" },
  { icon: "graph-up", text: "REAL-TIME ANALYTICS" },
  { icon: "person-badge", text: "CUSTOMER BEHAVIOR INSIGHTS" },
  { icon: "cloud", text: "CLOUD SYNC" },
  { icon: "shield-check", text: "FRAUD DETECTION" },
  { icon: "cash-stack", text: "AUTO PRICE UPDATES" },
  { icon: "alarm", text: "EXPIRY ALERTS" },
  { icon: "gear-wide-connected", text: "SELF-LEARNING SYSTEM" },
];

const aiBenefits = [
  "30% faster checkout process",
  "Reduces training time for new employees by 80%",
  "Eliminates 95% of manual PLU entry errors",
  "Provides real-time sales analytics",
  "Automatically detects scale tampering",
  "Reduces shrinkage by up to 40%"
];

  const [activeTab, setActiveTab] = useState('MODELS');
  
  // Define a constant for the active blue color
  const activeColor = '#3ec63e';
  const inactiveColor = '#9E9E9E';
  
  // Tabs with their default colors - we'll override these based on which tab is active
  const tabs = [
    { id: 'MODELS', defaultColor: activeColor },
    { id: 'INFORMATION', defaultColor: inactiveColor},
    {id: 'BENEFITS', defaultColor:inactiveColor},
  ];
  
  // Function to get the current color for a tab
  const getTabColor = (tabId) => {
    // When a tab is active, always use the active blue color
    // When inactive, use the inactive gray color
    return tabId === activeTab ? activeColor : inactiveColor;
  };
  
  const products = [
  {
    id: 1,
    image: img1,
    title: "AI SCALE X-9000 PRO",
    description: "Flagship AI scale with 99.7% recognition accuracy and real-time inventory updates.",
    isNew: true,
    isBestseller:false
  },
  {
    id: 2,
    image: img2,
    title: "AI SCALE X-7000 STANDARD",
    description: "Mid-range AI scale with 98% recognition accuracy and basic analytics.",
    isNew: false,
    isBestseller:true
  },
  {
    id: 3,
    image: img3,
    title: "AI SCALE X-5000 ENTRY",
    description: "Entry-level AI scale with 95% recognition accuracy for small retailers.",
    isNew: false,
    isBestseller:true
  },
  {
    id: 4,
    image: img4,
    title: "AI SCALE X-3000 COMPACT",
    description: "Compact AI scale with limited features for space-constrained locations.",
    isNew: true,
    isBestseller:false
  }
];
  // Information section bullet points
  const informationPoints = [ 
  "Maximum weighing: 6kg/15kg",
  "Minimum weighing: 40g",
  "Graduation value: 2g/5g",
  "Accuracy level: Level III",
  "Advanced computer vision recognizes 5000+ products instantly",
  "Self-learning algorithm improves accuracy over time",
  "Automatically generates PLU codes for new items",
  "Real-time inventory tracking and alerts",
  "Integrated fraud detection for weigh-based scams",
  "Cloud-connected for remote monitoring and updates",
  "Customer behavior analytics dashboard",
  "Predictive ordering suggestions",
  "Auto-price updates when items go on sale",
  "Compliance with all food safety regulations",
  "Seamless integration with POS systems"
  ];

  // Function to render content based on active tab
  const renderTabContent = () => {
    switch(activeTab) {
      case 'MODELS':
        return (
          <Row className="g-4">
            {products.map((product) => (
              <Col key={product.id} md={6} lg={4}>
                <Card className="h-100 border-0 shadow-sm">
                  <div className="position-relative">
                    <Card.Img variant="top" src={product.image} alt={product.title} className='p-5'/>
                    {product.isNew && (
                      <Badge 
                        className="position-absolute top-0 end-0 m-2 px-3 py-2" 
                        bg="primary"
                      >
                        NEW
                      </Badge>
                    )}
                    {product.isBestseller &&(
                      <Badge
                      className="position-absolute top-0 end-0 m-2 px-3 py-2" 
                        bg="primary"
                      >
                        Best Seller
                      </Badge>
                    )}
                  </div>
                  <Card.Body className="text-center">
                    <Card.Title className="fw-bold"
                    style={{fontFamily: "'Roboto Slab', serif", fontSize:"14px"}}
                    >{product.title}</Card.Title>
                    <Card.Text className="text-muted mt-2"
                    style={{fontFamily: "'Poppins', serif", fontSize:"12px"}}
                    >
                      {product.description}
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        );
      case 'INFORMATION':
        return (
          <div className="p-4">
            <h4 style={{fontFamily: "'Montserrat', serif", marginBottom: "20px"}}>Main Characteristic</h4>
            <ul className="information-list">
              {informationPoints.map((point, index) => (
                <li key={index} style={{fontFamily: "'Poppins', serif", fontSize: "14px", marginBottom: "15px"}}>
                  {point}
                </li>
              ))}
            </ul>
          </div>
        );
      case 'BENEFITS':
        return(
          <div className="p-4">
            <h4>Business Benefits</h4>
            <ul className="ai-benefits-list">
            {aiBenefits.map((benefit, index) => (
            <li key={index} style={{fontFamily: "'Poppins', serif", fontSize: "14px", marginBottom: "15px"}}>
              <i className="bi bi-check-circle-fill me-2" style={{color:"#3ec63e"}}></i>
              {benefit}
            </li>
            ))}
            </ul>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div>
      <div className='text-center'>
        <h2 style={{fontFamily: "'Montserrat', serif"}}>Retail AI Scales</h2>
        <p className='ml-5 mr-5 mt-4' style={{fontFamily: "'Poppins', serif", fontSize:"15px"}}>Next-generation intelligent scales with computer vision, AI-powered product recognition, 
    and real-time analytics for modern retail environments.</p>
      </div>
      
      <Container className="my-5">
        <Row>
          {/* Left Division - Image Carousel */}
          <Col md={6} className="mb-4 mb-md-0">
            <div className="border rounded p-3 h-100">
              <Carousel>
                <Carousel.Item>
                  <img
                    className="d-block w-100"
                    src={img1}
                    alt="First slide"
                  />
                  <Carousel.Caption>
                    {/* <h5>First slide</h5>
                    <p>Sample carousel caption text</p> */}
                  </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                  <img
                    className="d-block w-100"
                    src={img2}
                    alt="Second slide"
                  />
                  
                  {/* <Carousel.Caption>
                    <h5>Second slide</h5>
                    <p>Sample carousel caption text</p>
                  </Carousel.Caption> */}
                </Carousel.Item>
                <Carousel.Item>
                  <img
                    className="d-block w-100"
                    src={img3}
                    alt="Third slide"
                  />
                  {/* <Carousel.Caption>
                    <h5>Third slide</h5>
                    <p>Sample carousel caption text</p>
                  </Carousel.Caption> */}
                </Carousel.Item>
                <Carousel.Item>
                  <img
                    className="d-block w-100"
                    src={img4}
                    alt="Third slide"
                  />
                  {/* <Carousel.Caption>
                    <h5>Fourth slide</h5>
                    <p>Sample carousel caption text</p>
                  </Carousel.Caption> */}
                </Carousel.Item>
              </Carousel>
            </div>
          </Col>

          {/* Right Division - Icons Display */}
          <Col md={6}>
            <div className="border rounded p-3 h-100">
              <h4 className="mb-3">Features</h4>
              <Row className="g-3">
                {featureIcons.map((item, index) => (
                  <Col xs={4} key={index} className="text-center mb-3">
                    <div className=" mx-auto mb-2">
                      <i className={`bi bi-${item.icon}`}
                      style={{fontSize:"30px"}}
                      ></i>
                    </div>
                    <p className="small-text mb-0"
                    style={{fontSize:"10px"}}
                    >{item.text}</p>
                  </Col>
                ))}
              </Row>
            </div>
          </Col>
        </Row>
      </Container>

      <Container fluid className="p-0">
        {/* Custom Tabs */}
        <div className="position-relative">
          <Nav className="custom-tabs d-flex">
            {tabs.map((tab) => (
              <Nav.Item 
                key={tab.id} 
                className="tab-item" 
                style={{ 
                  backgroundColor: getTabColor(tab.id)
                }}
                onClick={() => setActiveTab(tab.id)}
              >
                <Nav.Link 
                  className={`py-3 px-4 text-white fw-bold border-0 ${activeTab === tab.id ? 'active' : ''}`}
                >
                  {tab.id}
                </Nav.Link>
              </Nav.Item>
            ))}
          </Nav>
        </div>

        {/* Tab Content Area */}
        <div className="bg-white p-4 border">
          {renderTabContent()}
        </div>

        {/* Custom CSS */}
        <style>{`
          .custom-tabs {
            display: flex !important;
            overflow-x: auto !important;
            position: relative !important;
          }

          .tab-item {
            position: relative !important;
            /* This creates a shape with straight left edge and slanted right edge */
            clip-path: polygon(0 0, 85% 0, 100% 100%, 0% 100%);
            margin-right: -20px; /* Negative margin creates the overlap effect */
            z-index: 1 !important;
            cursor: pointer !important;
            transition: background-color 0.3s ease !important;
          }

          /* Each subsequent tab needs higher z-index to properly overlap */
          .tab-item:nth-child(1) { z-index: 5; }
          .tab-item:nth-child(2) { z-index: 4; }
          .tab-item:nth-child(3) { z-index: 3; }
          .tab-item:nth-child(4) { z-index: 2; }
          .tab-item:nth-child(5) { z-index: 1; }

          /* Last tab can have a different shape if needed */
          .tab-item:last-child {
            margin-right: 0 !important;
            clip-path: polygon(0 0, 85% 0, 100% 100%, 0% 100%) !important;
          }

          .tab-item .nav-link {
            background: transparent !important;
            border-radius: 0 !important;
            padding: 15px 40px !important; /* Adjust padding as needed */
          }

          .tab-item .nav-link.active {
            font-weight: bold !important;
          }

          .information-list {
            padding-left: 25px !important;
          }
          
          .information-list li {
            position: relative !important;
            list-style-type: none !important;
            padding-left: 25px !important;
            margin-bottom: 15px !important;
          }
          
          .information-list li:before {
            content: "•" !important;
            position: absolute !important;
            left: 0 !important;
            color: #3ec63e !important;
            font-size: 24px !important;
            line-height: 1 !important;
          }
          
          .circular-icon {
            width: 80px !important;
            height: 80px !important;
            border-radius: 50% !important;
            background-color: #f8f9fa !important;
            border: 2px solid #3ec63e !important;
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
          }
        `}</style>
      </Container>
    </div>
  )
}

export default AIScale